var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.reset($event)
        }
      }
    },
    [
      _c("div", { staticClass: "modal__head text__bold text__center" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("FORGOT.TITLE")) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal__body" }, [
        _c("p", { staticClass: "text__center" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t(_vm.expiredMessage) || _vm.$t("FORGOT.P_1")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input__field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            attrs: {
              id: "reset_email",
              type: "email",
              name: "email",
              placeholder: " "
            },
            domProps: { value: _vm.email },
            on: {
              blur: _vm.validateEmail,
              focus: function($event) {
                return _vm.clearError("forgot")
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("label", { staticClass: "label", attrs: { for: "reset_email" } }, [
            _vm._v(_vm._s(_vm.$t("INPUT.EMAIL-AD")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal__footer margin-t__60" }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.error("forgot") || _vm.localError,
              expression: "error('forgot') || localError"
            }
          ],
          staticClass: "error-message",
          domProps: { innerHTML: _vm._s(_vm.error("forgot") || _vm.localError) }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn full__width",
            attrs: { type: "submit", disabled: _vm.isBtnDisabled }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.message || _vm.$t("LINK.RESET")) +
                "\n        "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }